"use strict";

require("core-js/modules/es.array.iterator");

var go = require("../Strict/go.js");

var isArray = require("../Strict/isArray.js");

var isIterable = require("../Strict/isIterable.js");

var isString = require("../Strict/isString.js");

var not = require("../Strict/not.js");

var reduce = require("../Strict/reduce.js");

var when = require("../Strict/when.js");

var clonedIterable = require("./clonedIterableSymbol.js");

const isEntries = a => not(isString(a)) && not(isArray(a)) && isIterable(a) && not(a[clonedIterable]) === true;

module.exports = objectDeep;

function objectDeep(entries) {
  return reduce((acc, [k, v]) => go(v, when(isEntries, objectDeep), res => (acc[k] = res, acc)), {}, entries);
}